document.addEventListener("DOMContentLoaded", function () {
  const emojiRegex =
    /([\u{1F300}-\u{1FAFF}\u{1F1E6}-\u{1F1FF}\u2600-\u26FF\u2700-\u27BF])/gu;

  function splitTextAndEmojis(text) {
    const result = [];
    let lastIndex = 0;

    for (const match of text.matchAll(emojiRegex)) {
      const index = match.index;
      if (index > lastIndex) {
        result.push({ type: "text", value: text.slice(lastIndex, index) });
      }
      result.push({ type: "emoji", value: match[0] });
      lastIndex = index + match[0].length;
    }

    if (lastIndex < text.length) {
      result.push({ type: "text", value: text.slice(lastIndex) });
    }

    return result;
  }

  const headings = document.querySelectorAll("h2.section__title.heading.h3");

  headings.forEach((heading) => {
    const originalText = heading.textContent.trim();
    const parts = splitTextAndEmojis(originalText);
    heading.innerHTML = parts
      .map((part) => {
        return part.type === "emoji"
          ? `<span class="styled-emoji">${part.value}</span>`
          : part.value;
      })
      .join("");
  });
});
